import { CSSProperties, ReactNode } from 'react';
import * as S from './styles';

export type TextProps = {
  $size: number;
  $color: string;
  $weight: 'light' | 'regular' | 'medium' | 'bold' | 'semibold';
  $align: 'left' | 'center' | 'right';
  $highContrast: boolean;
  $text: string | ReactNode;
  $quebraTexto?: boolean;
  style?: CSSProperties;
  $underline?: boolean;
  $utilizarReticencias?: boolean;
};

export default function Text(props: TextProps) {
  const { $text, $quebraTexto = true, $utilizarReticencias = false } = props;
  const propsTexto = { ...props, $quebraTexto, $utilizarReticencias };
  return <S.Texto {...propsTexto}>{$text}</S.Texto>;
}
